import { useContext, useEffect, useState } from 'react'
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from 'reactstrap'
import { Link } from 'react-router-dom'
import MainContainer from '../../components/modules/containers/MainContainer'
import PreLoader from '../../components/modules/loader'
import VisitContext from './../../store/visitContext'
import { patientHome } from '../../breadcrumRoutes.js'
import './home.scss'

const Index = () => {
  const { getData } = useContext(VisitContext)
  const [loading, setLoading] = useState(false)
  const _townshipDisplay = (townships) => {
    if (townships.length > 4) {
      return `${townships.length} townships`
    } else {
      {
        return townships.map((e) => {
          return e.short_code + ','
        })
      }
    }
  }

  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true)
      await getData({ me: true })
      setLoading(false)
    }
    fetchMyAPI()
  }, [])

  return (
    <>
      <MainContainer breadcrums={patientHome}>
        <Row className="d-flex flex-row justify-content-center head">
          <Col md={{ size: 4 }}>
            <Link to="add/visit/options">
              <Button block className="add-btn">
                Add New
              </Button>
            </Link>
          </Col>
        </Row>
        {loading && <PreLoader />}
        {!loading && (
          <Row>
            <VisitContext.Consumer>
              {({ data }) =>
                data.map((visit) => (
                  <Col md={{ size: 4, offset: 4 }}>
                    <Card className="main-card">
                      <CardBody className="d-flex flex-column justify-content-center">
                        <CardTitle className="mb-3 text-center" tag="h5">
                          <strong>Date</strong> : {visit.date.substr(0, 10)}
                        </CardTitle>
                        <CardSubtitle tag="h5" className="mb-3 text-center">
                          <strong>Township</strong> :{' '}
                          {_townshipDisplay(visit.townships)}
                        </CardSubtitle>
                        <Link to={`/visit-detail/${visit.id}`}>
                          <Button outline className="view-btn">
                            View Detail
                          </Button>
                        </Link>
                      </CardBody>
                    </Card>
                  </Col>
                ))
              }
            </VisitContext.Consumer>
          </Row>
        )}
      </MainContainer>
    </>
  )
}
export default Index
